var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapper__background",attrs:{"role":"presentation","aria-hidden":"true"}}),_vm._v(" "),_c('h1',{staticClass:"wrapper__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c(_setup.RichText,{staticClass:"wrapper__description",attrs:{"text":_setup.descriptionBody}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }